import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from "@spartacus/asm/root";
import { BaseSiteService } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import moment from 'moment';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { OrderHistoryService } from 'src/app/order-history/order-history.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from '../../shared/utils/common.utils';
import { MessageHistoryService } from '../message-history.service';

@Component({
    selector: 'app-message-history',
    templateUrl: './message-history.component.html',
    styleUrls: ['./message-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MessageHistoryComponent implements OnInit {
  notificationList = [];
  totalOrders: number = 0;
  orders = [];
  userId;
  pageLength = '18 per page';
  timeFrameList = ['Select', '1 Month', '3 Months', '6 Months'];
  pageList = [this.pageLength, '36 per page', '72 per page', 'All'];
  timeFrame = '6 Months';
  fromDate: any;
  toDate: any;

  searchNumber: any;


  dateError = false;

  pageSizeperPage = this.pageLength;
  pageSize = 18;
  curPage = 1;
  end: number;
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd;
  singleDateError = false;
  facetsList: any = [{ type: 'timeFrame', value: '6 Months' }];
  filters = {
    fields: 'DEFAULT',
    timeFrame: '6',
    pageNumber: this.curPage,
    pageSize: this.pageSize,
  };
  maxSelectionDate = new Date();

  dateFormat = 'MM/DD/YYYY';
  userDataSubscription: any;
  userInfo: any;
  FilteredData: any;
  allOrdersSubscription: any;
  xlsDownloaded: boolean = false;
  orderStatusList = [{ name: 'All', code: 'All' }, { name: 'Account and Payments', code: 'ACCOUNT_AND_PAYMENTS' },
  { name: 'Orders and Reservations', code: 'ORDER_AND_RESERVATION' },
  { name: 'Shipment Alerts', code: 'SHIPMENTS_ALERTS' }];
  orderStatusSub: Subscription;
  orderStatus = 'All'
  isFilterSelected = false;
  product: any;
  userAccountSub: Subscription;
  userAccountDetailsSub: Subscription;
  usergetDataObj: any;
  address: any;
  isComServeAgent: boolean = false;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  firewallExempt: boolean = false;
  applyFilterMobClicked:boolean = false
  sortDir:any =-1;
  baseSiteId: any;
  constructor(
    private readonly service: MessageHistoryService,
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly localeService: BsLocaleService,
    private readonly orderHistoryService: OrderHistoryService,
    private readonly router: Router,
    private baseSiteService: BaseSiteService,
    private locService: LoactionStripService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly sharedService: SharedService
  ) {
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
  }

  ngOnInit() {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });

    this.end = this.pageSize;
    this.getNotificationList();




  }

  refine(): void {
    this.modalService.open(this.facetsRwd, {
      windowClass: `refine-notification-modal ${this.baseSiteId}`
    });
  }

  hide(): void {
    this.applyFilterMobClicked = false;
    this.modalService.dismissAll(this.facetsRwd);
  }

  getNotificationList() {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      this.filters = this.getfilterQuery();
      this.showFacets(JSON.stringify(this.filters));
      if (userData) {
        this.locService.emitSelectedLocs.pipe(filter(res => !!res), take(1)).subscribe(locsData => {
          this.address = locsData.length ? locsData[0].formattedAddress : JSON.parse(sessionStorage.getItem('defaultLocation'))[0].formattedAddress;

        });
        const params = { userId: this.userId.uid };
        params['locId'] = this.getB2BUid();
        this.service.getNotificationHistory(params, this.filters);
        this.userDataSubscription = this.service.notificationData$.subscribe((res) => {
          if (res !== null) {
            try {
              this.isComServeAgent = res.isComServeAgent;
              this.notificationList = res?.messageDetails;
              if (res?.totalRows) {
                this.totalOrders = res?.totalRows;
              }
              this.cd.detectChanges();
              this.formatOrders();
              if (this.pageSize > this.totalOrders) {
                this.end = this.totalOrders;
                this.cd.detectChanges();
              } else {
                if (this.pageSize < this.totalOrders) {
                  this.end = this.pageSize * this.curPage;
                  if (this.end > this.totalOrders) {
                    this.end = this.totalOrders;
                  }
                  this.cd.detectChanges();
                }
              }
              this.notificationList = CommonUtils.sortArr(
                'SENT_DT',
                this.orders,
                'Date',
                this.sortDir
              );
              res = null;
              this.cd.detectChanges();
            } catch { }
            this.userDataSubscription?.unsubscribe();
          }
        });
      }
      this.userInfo?.unsubscribe();
    });
  }

  ngOnDestroy() {
    this.userDataSubscription?.unsubscribe();
    this.userInfo?.unsubscribe();
    this.allOrdersSubscription?.unsubscribe();
    this.userAccountSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
  }

  formatOrders() {
    this.orders = [];
    this.notificationList?.forEach((element) => {

      const data = {














        ACCOUNT_NUMBER: element?.ACCOUNT_NUMBER,
        BCC_EMAIL: element?.BCC_EMAIL,
        FROM_EMAIL: element?.FROM_EMAIL,
        MESSAGE_ID: element?.MESSAGE_ID,
        NOTIFICATION_NAME: element?.NOTIFICATION_NAME,
        NOTIFICATION_SUB_TYPE_DESC: element?.NOTIFICATION_SUB_TYPE_DESC,
        NOTIFICATION_TYPE_CODE: element?.NOTIFICATION_TYPE_CODE,
        ORDER_NUMBER: element?.ORDER_NUMBER,
        PO_NUMBER: element?.PO_NUMBER,
        ROW_NUM: element?.ROW_NUM,
        SENT_DT: element?.SENT_DT,
        SOURCE: element?.SOURCE,
        SUBJECT: element?.SUBJECT,
        TO_EMAIL: element?.TO_EMAIL,
      };
      this.orders.push(data);
    });
  }

  changePageSize() {
    this.curPage = 1;
    if (this.pageSizeperPage === this.pageLength) {
      this.pageSize = 18;
    }
    if (this.pageSizeperPage === '36 per page') {
      this.pageSize = 36;
    }
    if (this.pageSizeperPage === '72 per page') {
      this.pageSize = 72;
    }
    if (this.pageSizeperPage === 'All') {
      this.pageSize = this.totalOrders;
    }
    if (this.pageSize < this.totalOrders) {
      this.end = this.pageSize;
    } else {
      this.end = this.totalOrders;
    }
  }

  getCurrentPage(type) {
    this.curPage = type === 'prev' ? this.curPage - 1 : this.curPage + 1;
    window.scrollTo(0, 0);
    this.cd.detectChanges();
  }

  numberOfPages() {
    if (this.notificationList && this.totalOrders && Number(this.totalOrders) > 0 && this.pageSize > 0) {
      return Math.ceil(Number(this.totalOrders) / this.pageSize);
    } else {
      return 1;
    }
  }

  iconTypes = ICON_TYPE;

  sortColumn(event, fieldName, dataList, type): any {
    const caretUpClass = 'fa-caret-up';
    const target = event.currentTarget.children;
    const classList = target[0].classList;
    if (classList.contains(caretUpClass)) {
      this.sortDir = -1;
    } else {
      this.sortDir = 1;
    }
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  removeFacet(filter) {
    this.facetsList.forEach((element, index) => {
      if (element === filter) {
        this.facetsList.splice(index, 1);
        if (filter.type === 'date') {
          this.fromDate = undefined;
          this.toDate = undefined;
          this.timeFrame = 'Select';
        }









        if (filter.type === 'timeFrame') {
          this.timeFrame = 'Select';

        }



        if (filter.type === 'messageType') {
          this.orderStatus = 'All';
        }
        if (filter.type === 'searchNumber') {
          this.searchNumber = undefined;
        }
        this.curPage = 1;
        this.getNotificationList();
        this.cd.detectChanges();
      }
    });
  }

  applyFilter(type?: string) {
    if (type === 'mobile') {
      this.applyFilterMobClicked = true;
    }
    if (this.fromDate && this.toDate) {
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
        return false;
      } else {
        this.dateError = false;
      }
    }
    const params = { userId: this.userId.uid };
    params['locId'] = this.getB2BUid();
    this.filters = this.getfilterQuery();
    this.showFacets(JSON.stringify(this.filters));
    this.filters.pageNumber = 1;
    this.curPage = 1;
    this.service.getNotificationHistory(params, this.filters);
    this.userDataSubscription = this.service.notificationData$.subscribe((res) => {
      if (res !== null) {
        this.notificationList = res?.messageDetails;
        if (res?.totalRows) {
          this.totalOrders = res?.totalRows;
        }
        this.cd.detectChanges();
        this.formatOrders();
        if (this.pageSize > this.totalOrders) {
          this.end = this.totalOrders;
          this.cd.detectChanges();
        } else {
          if (this.pageSize < this.totalOrders) {
            this.end = this.pageSize * this.curPage;
            if (this.end > this.totalOrders) {
              this.end = this.totalOrders;
            }
            this.cd.detectChanges();
          }
        }
        this.notificationList = CommonUtils.sortArr(
          'SENT_DT',
          this.orders,
          'Date',
          this.sortDir
        );
        this.cd.detectChanges();

        if (type === 'mobile') {
          this.hide();
        }
        this.userDataSubscription?.unsubscribe();
      }
    });
    window.scrollTo(0, 0);
    return true;
  }

  showFacets(data) {
    const facets = JSON.parse(data);
    delete facets.fields;
    delete facets.pageNumber;
    delete facets.numberrows;
    if (facets.endDate) {
      facets.date = `${moment(this.fromDate).format(
        this.dateFormat
      )} - ${moment(this.toDate).format(this.dateFormat)}`;
      delete facets.startDate;
      delete facets.endDate;
    }
    if (facets.timeFrame && facets.timeFrame !== 'Select') {
      facets.timeFrame = this.timeFrame;
    } else if (facets.timeFrame && facets.timeFrame === 'Select') {
      delete facets.timeFrame;
    }




    if (facets.messageType === 'All') {
      delete facets.messageType;
    } else {
      facets.messageType = facets.messageType.split('_').join(' ');
    }
    this.facetsList = Object.entries(facets).map(([type, value]) => ({
      type,
      value,
    }));
  }

  getfilterQuery() {





    const data: any = {
      fields: 'DEFAULT',
      pageNumber: this.curPage,
      numberrows: this.pageSize,
    };






    if (this.searchNumber) {
      data.searchNumber = this.searchNumber;
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        data.timeFrame = '30';
      }
      if (this.timeFrame === '1 Month') {


        data.timeFrame = '30';
      }
      if (this.timeFrame === '3 Months') {

        data.timeFrame = '90';
      }
      if (this.timeFrame === '6 Months') {

        data.timeFrame = '180';
      }
      if (this.timeFrame === '1 Year') {

        data.timeFrame = '365';
      }
    }
    if (this.fromDate && this.toDate) {
      if (this.timeFrame === 'Select' && data.timeFrame) {
        delete data.timeFrame;
      }
      data.startDate = moment(this.fromDate).format('MM/DD/YYYY');
      data.endDate = moment(this.toDate).format('MM/DD/YYYY');
    } else if (
      (!this.fromDate && this.toDate) ||
      (this.fromDate && !this.toDate)
    ) {
      this.singleDateError = true;
    } else {

    }



    if (this.orderStatus) {
      data.messageType = this.orderStatus;
    }
    return data;
  }

  validateDate() {
    this.timeFrame = this.fromDate || this.toDate ? 'Select' : this.timeFrame;
    if (this.fromDate && this.toDate) {
      this.singleDateError = false;
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
      this.isFilterSelected = true;
    }
  }

  clearDateRange() {
    this.fromDate = undefined;
    this.toDate = undefined;
    this.isFilterSelected = true;
  }

  clearFilters() {
    this.facetsList = [];
    this.filters = {
      fields: 'DEFAULT',
      timeFrame: 'All',
      pageNumber: 1,
      pageSize: this.pageSize,
    };
    this.curPage = 1;

    this.fromDate = undefined;
    this.toDate = undefined;



    this.timeFrame = 'Select';
    this.orderStatus = 'All';
    this.searchNumber = undefined;
    this.getNotificationList();
    this.isFilterSelected = false;


  }

  onKeyPress(value: any) {
    if (value) this.isFilterSelected = true;
  }

  getSelectedProduct(params) {
    if (params) this.isFilterSelected = true;
    this.product = params;
  }

  onDetailsPage(messageid) {
    localStorage.setItem('messageId', JSON.stringify(messageid));
    this.router.navigate(['/notificationsmessageDetailsPage']);
  }

  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    }
    else {

      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }

  customOrderPoSearch() {
    if (this.searchNumber === '') {
      return false;
    }
    this.isFilterSelected = true;
    this.facetsList = [];
    this.cd.detectChanges();
    this.filters = {
      fields: 'DEFAULT',
      timeFrame: 'All',
      pageNumber: 1,
      pageSize: this.pageSize,
    };
    this.curPage = 1;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.timeFrame = 'Select';
    this.orderStatus = 'All';

    this.getNotificationList();
  }

  asmStringCheck(){




    if(this.isComServeAgent && this.isAsmUser){
      return true;
    }
    return false;
  }
}
